/* eslint-disable */
import BuffetIcon from "@/assets/icon/BuffetIcon";
import { TLIconDefaultColor } from "@/helper";
import {
	Geometry2d,
	RecordProps,
	getDefaultColorTheme,
	Rectangle2d,
	ShapeUtil,
	SVGContainer,
	T,
	TLBaseShape,
	TLResizeInfo,
	resizeBox,
	DefaultColorStyle,
	TLDefaultColorStyle,
} from "tldraw";

type ICustomShape = TLBaseShape<
	"buffet_element",
	{
		w: number;
		h: number;
		color: TLDefaultColorStyle;
	}
>;

// [2]
export class BuffetElement extends ShapeUtil<ICustomShape> {
	static override type = "buffet_element" as const;
	static override props: RecordProps<ICustomShape> = {
		w: T.number,
		h: T.number,
		color: DefaultColorStyle as any,
	};

	// [b]
	getDefaultProps(): ICustomShape["props"] {
		return {
			w: 32,
			h: 15,
			color: TLIconDefaultColor,
		};
	}

	// [c]
	override canEdit() {
		return true;
	}
	override canResize() {
		return true;
	}
	override isAspectRatioLocked() {
		return false;
	}

	// [d]
	getGeometry(shape: ICustomShape): Geometry2d {
		return new Rectangle2d({
			width: shape.props.w,
			height: shape.props.h,
			isFilled: true,
		});
	}

	// [e]
	override onResize(shape: ICustomShape, info: TLResizeInfo<any>) {
		return resizeBox(shape, info);
	}

	// [f]
	component(shape: ICustomShape) {
		const theme = getDefaultColorTheme({ isDarkMode: false });
		const themeColor = theme[shape.props.color] as { solid: string };
		const fill = themeColor.solid;
		return (
			<SVGContainer>
				<BuffetIcon fill={fill} />
			</SVGContainer>
		);
	}

	// [g]
	indicator() {
		return;
	}
}
